import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// amplify
import { Auth } from 'aws-amplify'

import { push } from 'connected-react-router'

interface UserState {
    data: object | null | undefined,
    cognitoData: object | null | undefined
}
interface Credentials {
    email: string,
    password: string
}

const initialState: UserState = {
    data: null,
    cognitoData: null
}

export const cognitoSignIn: any = createAsyncThunk(
    'user/cognitoSignIn',
    async (credentials: Credentials, { dispatch }) => {
        try {
            const user = await Auth.signIn(credentials.email, credentials.password)
            console.log('cognito sign in response', user)
            const cognitoData = {
                email: user.email,
                session: {
                    accessToken: user.signInUserSession.accessToken.jwtToken,
                    idToken: user.signInUserSession.idToken.jwtToken,
                    refreshToken: user.signInUserSession.refreshToken.jwtToken
                }
            }
            dispatch(push('/admin/dashboard'))
            return cognitoData
        } catch (err) {
            console.error(err)
        }
    }
)

export const reloadCognitoData: any = createAsyncThunk(
    'user/reloadCognitoData',
    async (args, { dispatch }) => {
        try {
            const user = await Auth.currentAuthenticatedUser()
            if (user != 'The user is not authenticated') {
                console.log('cognito reload response', user)
                const cognitoData = {
                    email: user.email,
                    session: {
                        accessToken: user.signInUserSession.accessToken.jwtToken,
                        idToken: user.signInUserSession.idToken.jwtToken,
                        refreshToken: user.signInUserSession.refreshToken.jwtToken
                    }
                }
                return cognitoData
            } else {
                return
            }
        } catch (err) {
            console.error(err)
        }
    }
)

export const cognitoSignOut: any = createAsyncThunk(
    'user/cognitoSignOut',
    async (params, { dispatch }) => {
        try {
            await Auth.signOut()
            console.log('cognito sign out successful')
            dispatch(push('/'))
            return
        } catch (err) {
            console.error(err)
        }
    }
)

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        clearLocalUserData: (state) => {
            state.data = null
        }
    },
    extraReducers: (builder) => {
        builder.addCase(cognitoSignIn.fulfilled, (state, { payload }) => {
            state.cognitoData = payload
        })
        builder.addCase(cognitoSignOut.fulfilled, (state, { payload }) => {
            state.cognitoData = null
            state.data = null
        })
        builder.addCase(reloadCognitoData.fulfilled, (state, { payload }) => {
            state.cognitoData = payload
        })
    }
})

export const { clearLocalUserData } = userSlice.actions
export default userSlice.reducer